import React, { Component, Fragment } from "react";
import { Row, Col, Container, Image } from "react-bootstrap";

import styles from "./ResultsOne.module.scss";

import Apples from "../../assets/png/Apples.png";
import Oranges from "../../assets/png/Oranges.png";
import Stacked from "../../assets/png/Stacked.png";
import Leaf from "../../assets/png/Leaf.png";
import AgriFreshLogo from "../../assets/png/AgriFreshLogo.png";

export default class ResultsOne extends Component {
  render() {
    return (
      <section id={styles.ResultsOne}>
        <Container fluid id="AgriFreshPhotos">
          <Row>
            <Col lg={6} className={styles.containerTop}>
              <div id={styles.Box1}>
                <span>
                  <Image src={AgriFreshLogo} id={styles.AgriFreshLogo}></Image>
                  <Image src={Leaf} id={styles.Leaf}></Image>
                  <br></br>
                  <p id={styles.SubHeader}>
                    SPOILED PRODUCE NO MORE<sup>TM</sup>
                  </p>
                </span>
              </div>
              <br></br>
              <div id={styles.Box2}>
                <p id={styles.Text1}>
                  Check out our photos, taken <i>one month</i> after purchase!
                </p>
                <p id={styles.Text2}>
                  Photos show produce{" "}
                  <b>treated with our unique AgriFresh technology (left)</b> and
                  <b> untreated produce (right).</b>
                </p>
                <p id={styles.Text3}>
                  *Expected results may vary from fruit to fruit and vegetable
                  to vegetable.
                </p>
              </div>
              <div id={styles.Box3}>
                <Image src={Stacked} id={styles.Stacked}></Image>
              </div>
            </Col>

            <Col lg={6} className={styles.containerBottom}>
              <p id={styles.FruitHeader1}>apples</p>
              <Image src={Apples} id={styles.Apples}></Image>
              <p id={styles.FruitHeader2}>oranges</p>
              <Image src={Oranges} id={styles.Oranges}></Image>
            </Col>
          </Row>
        </Container>
      </section>
    );
  }
}
